<template>
    <div class="page-container">
        <img class="my-asset-bg" src="../images/asset_bg.webp" alt="bgf">
        <div class="assets-page-container">
            <div class="tab-container">
                <div class="asset-tab" :class="{ 'active': this.currentSelectedTab === 'USDT'}"
                     @click="onTabClick('USDT')">{{ this.localize('USD资产') }}
                </div>
                <div class="asset-tab" :class="{ 'active': this.currentSelectedTab === 'FAC'}"
                     @click="onTabClick('FAC')">{{ this.localize('FAC资产') }}
                </div>
            </div>
            <div class="assets-info-container" v-if="this.currentSelectedTab === 'USDT'">
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('NFT卡牌：') }}</div>
                    <div class="asset-label">{{ this.nftList.length + '/' + this.totalNftPrice.toFixed(1) }}</div>
                </div>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('总能量：') }}</div>
                    <div class="asset-label">{{ this.totalEnergy.toFixed(1) }}</div>
                </div>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('共振金：') }}</div>
                    <div class="asset-label">{{ this.resonanceDeposit.toFixed(1) }}</div>
                </div>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('总收益：') }}</div>
                    <div class="asset-label-with-arrow">
                        <div>{{ this.totalRewardU.toFixed(1) }}U</div>
                        <img class="asset-arrow-down" :class="{'rotate-180': this.displayRewardUDetail === true}"
                             src="../images/arrow_down.svg" alt="arrow down" @click="toggleDisplayRewardU"></div>
                </div>
                <div class="asset-row" v-if="this.displayRewardUDetail === true">
                    <div class="asset-label">{{ this.localize('共振奖励：') }}</div>
                    <div class="asset-label">{{ this.totalResonanceRewardU.toFixed(1) + '/' }}
                        <span class="asset-label-available">{{this.availableResonanceRewardU.toFixed(1)}} </span>
                        U</div>
                </div>
                <div class="asset-row" v-if="this.displayRewardUDetail === true">
                    <div class="asset-label">{{ this.localize('直推奖励：') }}</div>
                    <div class="asset-label">{{ this.totalDirectReferrerRewardU.toFixed(1) + '/'}}
                        <span class="asset-label-available">{{this.availableDirectReferrerRewardU.toFixed(1)}} </span>
                        U</div>
                </div>
                <div class="asset-row" v-if="this.displayRewardUDetail === true">
                    <div class="asset-label">{{ this.localize('层级奖励：') }}</div>
                    <div class="asset-label">{{ this.totalLevelReward.toFixed(1) + '/' }}
                        <span class="asset-label-available">{{this.availableLevelReward.toFixed(1)}} </span>
                        U</div>
                </div>
                <div class="asset-row" v-if="this.displayRewardUDetail === true">
                    <div class="asset-label">{{ this.localize('社区奖励：') }}</div>
                    <div class="asset-label">{{ this.totalCommunityReward.toFixed(1) + '/' }}

                        <span class="asset-label-available">{{this.availableCommunityReward.toFixed(1)}} </span>
                        U</div>
                </div>
                <div v-if="this.displayRewardUDetail === true && this.isNodeHolder === true">
                    <div class="asset-label">{{ this.localize('节点分红：') }}</div>
                    <div class="asset-label">{{ this.nodeRewardFac }}U</div>
                </div>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('可领取：') }}</div>
                    <div class="asset-label-available-total">{{ this.totalWithdrawableU.toFixed(1) }}U</div>
                </div>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('已领取：') }}</div>
                    <div class="asset-label">{{ this.totalWithdrawnU?.toFixed(1) }}U</div>
                </div>
            </div>
            <div class="assets-info-container" v-if="this.currentSelectedTab === 'FAC'">
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('我的算力：') }}</div>
                    <div class="asset-label">{{ this.totalComputingPower?.toFixed(1) }}</div>
                </div>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('我的能量：') }}</div>
                    <div class="asset-label">{{ this.totalEnergy?.toFixed(1) }}</div>
                </div>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('我的燃料：') }}</div>
                    <div class="asset-label">{{ this.totalFuel.toFixed(1) }}</div>
                </div>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('我的矿池：') }}</div>
                    <div class="asset-label-with-arrow">
                        <div>{{ this.myMiningPool.toFixed(1) }}</div>
                        <img class="asset-arrow-down" :class="{'rotate-180': this.displayRewardFacDetail === true}"
                             src="../images/arrow_down.svg" alt="arrow down" @click="toggleDisplayRewardFAC"></div>

                </div>
                <template v-if="this.displayRewardFacDetail === true">
                    <div v-for="(item, index) in this.lastTenPeriodsFacInfo" :key="`item-${index}`" class="asset-row-daily">
                        <div class="asset-label-daily">{{ item.timeString }}</div>
                        <div class="asset-label-daily">{{ item.amount + '/' + item.released }}</div>
                    </div>
                </template>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('矿池释放FAC：') }}</div>
                    <div class="asset-label">{{ this.computingPowerReleaseFac.toFixed(1) }}</div>
                </div>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('社区奖励FAC：') }}</div>
                    <div class="asset-label">{{ this.communityRewardFac.toFixed(1)  + '/' + this.communityRewardFacWithdrawn.toFixed(1) }}</div>
                </div>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('节点分红FAC：') }}</div>
<!--                    <div class="asset-label">{{ this.nodeRewardFac.toFixed(1) }}</div>-->
                    <div class="asset-label-with-arrow">
                        <div>{{ this.nodeRewardFac.toFixed(1) }}</div>
                        <img class="asset-arrow-down" :class="{'rotate-180': this.displayNodeRewardFacDetail === true}"
                             src="../images/arrow_down.svg" alt="arrow down" @click="toggleDisplayNodeRewardFAC"></div>
                </div>

                <template v-if="this.displayNodeRewardFacDetail === true">
                    <div v-for="(item, index) in this.lastTenPeriodsNodeRewardFacInfo" :key="`item-${index}`" class="asset-row-daily">
                        <div class="asset-label-daily">{{ item.timeString }}</div>
                        <div class="asset-label-daily">{{ item.amount + '/' + item.released }}</div>
                    </div>
                </template>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('节点分红释放FAC：') }}</div>
                    <div class="asset-label">{{ this.nodeReleaseRewardFac.toFixed(1) }}</div>
                </div>
<!--                <div class="asset-row">-->
<!--                    <div class="asset-label">{{ this.localize('已释放节点分红FAC：') }}</div>-->
<!--                    <div class="asset-label">{{ this.nodeReleaseRewardFac.toFixed(1) }}</div>-->
<!--                </div>-->
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('平台分红FAC：') }}</div>
                    <div class="asset-label">0</div>
                </div>


                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('可领取FAC：') }}</div>
                    <div class="asset-label">{{ this.totalWithdrawableFac.toFixed(1) }}</div>
                </div>
                <div class="asset-row">
                    <div class="asset-label">{{ this.localize('已领取FAC：') }}</div>
                    <div class="asset-label">{{ this.myDistributedFacReward.toFixed(1) }}</div>
                </div>
            </div>

            <div class="claim-btn" @click="onClaim">{{ this.getBtnTxt() }}</div>

        </div>
    </div>
</template>
<script>
import {
    getDistributionPeriod,
    getLpLaunchAt,
    getLevelRewardDistributed,
    getMyBurnableNftTokenId,
    getMyBurnableNftTokenIdForFacToken,
    nftEthCall,
    interactorEthCall,
    lpEthCall,
    sendInteractorTrans,
    sendLpTrans
} from "@/utils/web3Helper";
import {parseUnits, formatUnits} from 'ethers'
import {showToast} from "@/utils/toastHelper";
import {hideLoading, showLoading} from "@/utils/spinnerHelper";

const moment = require('moment-timezone')
import {postRequestAsync} from '@/utils/request'
import {truncateDecimals, sleep, getNftStateCode} from '@/utils/methods'
import {v4} from "uuid";

export default {
    name: 'AssetsPage',
    props: {
        msg: String
    },
    inject: ['langStore', 'localize'],
    data() {
        return {
            totalResonanceRewardU: 0,
            distributedResonanceRewardU: 0,
            availableResonanceRewardU: 0,

            totalDirectReferrerRewardU: 0,
            distributedDirectReferrerRewardU: 0,
            availableDirectReferrerRewardU: 0,

            computingPower: 0,
            myPendingFacReward: 0,
            totalComputingPower: 0,
            totalFuel: 0,
            myDistributedFacReward: 0,

            totalCommunityReward: 0,
            distributedCommunityReward: 0,
            availableCommunityReward: 0,

            totalLevelReward: 0,
            availableLevelReward: 0,
            distributedLevelReward: 0,

            totalNodeReward: 0,
            availableNodeReward: 0,
            distributedNodeReward: 0,

            currentSelectedTab: 'USDT',
            nftList: [],
            totalNftPrice: 0,
            totalEnergy: 0,
            displayRewardUDetail: false,
            displayRewardFacDetail: false,
            displayNodeRewardFacDetail: false,
            myMiningPool: 0,
            availableFac: 0,
            computingPowerReleaseFac: 0,
            lastTenPeriodsFacInfo: [],
            lastTenPeriodsNodeRewardFacInfo: [],
            communityRewardFac: 0,
            communityRewardFacWithdrawn: 0,
            nodeRewardFac: 0,
            nodeReleaseRewardFac: 0,
            platformRewardFac: 0,
            resonanceDeposit: 0,
            withdrawableTime: 1762564380
        }
    },
    computed: {
        myWalletAddress() {
            if (window.location.href.includes('localhost')) {
                return this.$store.state.connectedWallet
                // return '0xADb47b8eb5e72E90a03Cb37De03472BEe967E875'
                // return '0x728797007491170bce5b3fca0e41e9f84ede39ef'
            } else {
                return this.$store.state.connectedWallet
            }
        },
        totalWithdrawableU() {
            return this.totalRewardU - this.totalWithdrawnU
        },
        totalWithdrawnU() {
            return this.distributedCommunityReward + this.distributedLevelReward + this.distributedResonanceRewardU + this.distributedDirectReferrerRewardU
        },
        totalRewardU() {
            return this.totalResonanceRewardU + this.totalDirectReferrerRewardU + this.totalLevelReward + this.totalCommunityReward
        },
        totalWithdrawableFac() {
            return this.computingPowerReleaseFac + this.communityRewardFac + this.nodeReleaseRewardFac + this.platformRewardFac - this.myDistributedFacReward
        }
    },
    watch: {
        async myWalletAddress(newVal, oldVal) {
            console.log('watch myWalletAddress')
            if (!newVal) return
            if (newVal === oldVal) return
            const loadingId = v4()
            showLoading(this.localize('加载中'), loadingId)
            try {
                await this.initAssetPage()

            } finally {
                hideLoading('all')
            }

        }
    },
    async mounted() {
        if (this.myWalletAddress) {
            const loadingId = v4()
            showLoading(this.localize('加载中'), loadingId)
            try {
                await this.initAssetPage()
            } finally {
                hideLoading('all')
            }

        }
    },
    methods: {
        async initAssetPage() {
            const tokenIds = await nftEthCall('getOwnerTokens', [this.myWalletAddress])
            console.log(`tokenIds: ${tokenIds}`)

            this.nftResonanceRewardExpireTime = Number(await nftEthCall('nftResonanceRewardExpireTime'))
            console.log(`this.nftResonanceRewardExpireTime: ${this.nftResonanceRewardExpireTime}`)
            this.resonancePeriod = Number(await nftEthCall('resonancePeriod'))
            console.log(`this.resonancePeriod: ${this.resonancePeriod}`)
            this.nftExpireTime = Number(await nftEthCall('nftExpireTime'))
            console.log(`this.nftExpireTime: ${this.nftExpireTime}`)
            this.nftList = []
            this.totalNftPrice = 0
            this.totalEnergy = 0
            if (Array.isArray(tokenIds) && tokenIds.length > 0) {
                console.log(`tokenIds: ${tokenIds}`)
                for (const tokenId of tokenIds[0]) {
                    console.log(`tokenId: ${tokenId}`)
                    const tokenInfo = (await nftEthCall('getNFTInfo', [Number(tokenId)]))[0]
                    console.log(`tokenId: ${tokenId}`)
                    const toPush = {
                        name: tokenInfo['2'],
                        tokenId: tokenId,
                        nftType: Number(tokenInfo['0']),
                        price: Number(formatUnits(tokenInfo['6'] / 2n, 18)),
                        energy: Number(tokenInfo['3']) / Math.pow(10, 18),
                        energyRemain: Number(formatUnits(tokenInfo['3'] - tokenInfo['4'], 18)),
                        computingPower: formatUnits(tokenInfo['5'], 18),
                        fuel: Number(formatUnits(tokenInfo['6'], 18)),
                        fuelUsed: Number(formatUnits(tokenInfo['11'], 18)),
                        fuelRemain: Number(formatUnits(tokenInfo['6'], 18)) - Number(formatUnits(tokenInfo['11'], 18)),
                        resonanceDeposit: formatUnits(tokenInfo['6'] / 2n * 15n / 10n, 18),
                        startResonanceTime: parseInt(tokenInfo['7']),
                        startResonanceTimeString: moment(parseInt(tokenInfo['7'])).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss'),
                        resonanceDepositWithdrawTimestamp: parseInt(moment(Number(tokenInfo['8']) * 1000).format('X')),
                        round: tokenInfo['9'],
                    }
                    const stateCode = getNftStateCode(toPush, this.resonancePeriod, this.nftExpireTime, this.nftResonanceRewardExpireTime)
                    if (stateCode !== -1) {
                        this.nftList.push(toPush)
                        this.totalNftPrice += toPush.price
                        this.totalEnergy += toPush.energyRemain
                        console.log(`toPush.fuelUsed: ${toPush.fuelUsed}`)
                        this.totalFuel += toPush.fuelRemain
                    }

                }
                await this.getTotalRewardU()

                const totalComputingPower = await lpEthCall('computingPowerMap', [this.myWalletAddress])
                this.totalComputingPower += Number(formatUnits(totalComputingPower.toString(), 18))
            }
            await this.getMyFacRewardInfo()

        },
        async getMyFacRewardInfo() {
            const [myDistributedFacReward, getMyFacResult, communityFacRewardResult] = await Promise.all([
                lpEthCall('withdrawnRewardMap', [this.myWalletAddress]),
                postRequestAsync('fac/getMyFac', {
                    wallet: this.myWalletAddress
                }),
                postRequestAsync('reward/getCommunityFacReward', {
                    wallet: this.myWalletAddress
                })
            ])
            this.myDistributedFacReward = Number(formatUnits(myDistributedFacReward.toString(), 18))

            if (getMyFacResult?.code === 200 && getMyFacResult?.msg?.totalFac) {
                this.myMiningPool = Number(formatUnits(getMyFacResult?.msg?.totalFac, 18))
                if (getMyFacResult?.msg?.nodeRewardFac) {
                    this.nodeRewardFac = Number(formatUnits(getMyFacResult?.msg?.nodeRewardFac, 18))
                }
                if (getMyFacResult?.msg?.releaseNodeAmount) {
                    this.nodeReleaseRewardFac = Number(formatUnits(getMyFacResult?.msg?.releaseNodeAmount, 18))
                }

                if (getMyFacResult?.msg?.releaseAmount) {
                    this.computingPowerReleaseFac = Number(formatUnits(getMyFacResult?.msg?.releaseAmount, 18))
                }

                this.availableFac = this.computingPowerReleaseFac + this.nodeReleaseRewardFac - this.myDistributedFacReward
                if (Array.isArray(getMyFacResult?.msg?.lastTenPeriods) && getMyFacResult?.msg?.lastTenPeriods?.length > 0) {
                    this.lastTenPeriodsFacInfo = getMyFacResult?.msg?.lastTenPeriods.sort((a, b) => b.time - a.time).map((item, index) => {
                        const timeString = moment(item.time * 1000).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss')
                        let amount = 0
                        if (item.nftGenerated) {
                            amount = Number(formatUnits(item.nftGenerated, 18)).toFixed(1)
                        }
                        let released = 0
                        if (item.releaseAmount) {
                            released = Number(formatUnits(item.releaseAmount, 18)).toFixed(1)
                        }

                        return {timeString, amount, released}
                    })
                }
                if (Array.isArray(getMyFacResult?.msg?.lastTenPeriodsNodeReward) && getMyFacResult?.msg?.lastTenPeriodsNodeReward?.length > 0) {
                    this.lastTenPeriodsNodeRewardFacInfo = getMyFacResult?.msg?.lastTenPeriodsNodeReward.sort((a, b) => b.time - a.time).map((item, index) => {
                        const timeString = moment(item.time * 1000).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss')
                        let amount = 0
                        if (item.nftGenerated) {
                            amount = Number(formatUnits(item.nodeReward, 18)).toFixed(1)
                        }
                        let released = 0
                        if (item.releaseAmount) {
                            released = Number(formatUnits(item.releaseAmount, 18)).toFixed(1)
                        }
                        return {timeString, amount, released}
                    })
                }
            }

            if (communityFacRewardResult?.code === 200 && communityFacRewardResult?.msg?.total) {
                this.communityRewardFac = parseFloat(communityFacRewardResult?.msg?.total)
                this.communityRewardFacWithdrawn = parseFloat(communityFacRewardResult?.msg?.withdrawn)
            }
        },
        toggleDisplayRewardU() {
            this.displayRewardUDetail = !this.displayRewardUDetail
        },
        toggleDisplayRewardFAC() {
            this.displayRewardFacDetail = !this.displayRewardFacDetail
        },
        toggleDisplayNodeRewardFAC() {
            this.displayNodeRewardFacDetail = !this.displayNodeRewardFacDetail
        },
        async getTotalRewardU() {
            const [
                resonanceRewardInfo,
                directReferrerRewardInfo,
                distributedCommunityReward,
                distributedLevelReward,
                levelRewardResult,
                communityRewardResult,
                resonanceDepositInfo,
                cpResult,
                fuelResult
            ] = await Promise.all([
                interactorEthCall('resonanceRewardMap', [this.myWalletAddress]),
                interactorEthCall('directReferrerRewardMap', [this.myWalletAddress]),
                interactorEthCall('communityRewardDistributedMap', [this.myWalletAddress]),
                getLevelRewardDistributed(this.myWalletAddress),
                postRequestAsync('reward/getTotalLevelReward', {
                    wallet: this.myWalletAddress,
                }),
                postRequestAsync('reward/getCommunityReward', {
                    wallet: this.myWalletAddress,
                }),
                interactorEthCall('resonanceDepositMap', [this.myWalletAddress]),
                this.getMyComputingPower(),
                this.getNodeFuel()
            ])

            // 处理 resonanceRewardInfo
            console.log(`resonanceRewardInfo: ${resonanceRewardInfo[0][0]}`)
            this.totalResonanceRewardU = Number(formatUnits(resonanceRewardInfo[0][0], 18))
            this.distributedResonanceRewardU = Number(formatUnits(resonanceRewardInfo[0][1], 18))
            this.availableResonanceRewardU = this.totalResonanceRewardU - this.distributedResonanceRewardU

            console.log(`directReferrerRewardInfo: ${directReferrerRewardInfo[0][0]}`)
            this.totalDirectReferrerRewardU = Number(formatUnits(directReferrerRewardInfo[0][0], 18))
            this.distributedDirectReferrerRewardU = Number(formatUnits(directReferrerRewardInfo[0][1], 18))
            this.availableDirectReferrerRewardU = this.totalDirectReferrerRewardU - this.distributedDirectReferrerRewardU

            this.distributedLevelReward = Number(formatUnits(distributedLevelReward, 18))
            if (levelRewardResult?.code === 200 && levelRewardResult?.msg?.totalLevelReward !== null) {
                this.totalLevelReward = levelRewardResult.msg.totalLevelReward
                this.availableLevelReward = levelRewardResult.msg.totalLevelReward - this.distributedLevelReward
            }

            this.distributedCommunityReward = Number(formatUnits(distributedCommunityReward.toString(), 18))
            if (communityRewardResult?.code === 200 && communityRewardResult?.msg?.communityReward !== null) {
                this.availableCommunityReward = communityRewardResult.msg.communityReward - this.distributedCommunityReward
                this.totalCommunityReward = communityRewardResult.msg.communityReward
            }
            console.log(`resonanceDepositInfo: ${resonanceDepositInfo}`)

            const isResonanceDepositInUse = resonanceDepositInfo[3]
            if (isResonanceDepositInUse) {
                this.resonanceDeposit = 0
            } else {
                this.resonanceDeposit = Number(formatUnits(resonanceDepositInfo[0].toString(), 18))
            }
            // console.log(`distributedCommunityRewardInfo: ${distributedCommunityReward}`)
        },
        onTabClick(tab) {
            this.currentSelectedTab = tab
        },
        async onClaim() {
            const current = parseInt(moment().format('X'))
            if (current < this.withdrawableTime) {
                showToast(this.localize('本操作将在24小时公测期后开放'))
                return
            }
            if (this.currentSelectedTab === 'FAC') {
                // await this.onClaimAllFacReward()
                await this.onClaimCommunityFacReward()
            } else if (this.currentSelectedTab === 'USDT') {
                await this.onClaimAllUsdtReward()
            }

        },
        async onClaimCommunityFacReward () {

            if (Number(this.communityRewardFac.toFixed(10)) <= 0) {
                showToast(this.localize('没有可提取的FAC'))
                return
            }
            const withdrawableCommFac = this.communityRewardFac - this.communityRewardFacWithdrawn
            if (Math.floor(withdrawableCommFac) <= 0) {
                showToast(this.localize('没有可提取的FAC'))
                return
            }
            const loadingId = v4()
            showLoading(this.localize('操作中'), loadingId)
            try {
                const {tokenId, amount} = await getMyBurnableNftTokenIdForFacToken(this.myWalletAddress, parseUnits(withdrawableCommFac.toFixed(10), 18))
                if (tokenId === null) {
                    showToast(this.localize('没有可用的能量'))
                    hideLoading(loadingId)
                    return
                }

                const withdrawableFac = Math.floor(withdrawableCommFac).toString()
                const result = await postRequestAsync('sig/getLpClaimCommunityRewardSig', {
                    wallet: this.myWalletAddress,
                    amount: withdrawableFac,
                    tokenId: tokenId
                })
                if (result.code === 700) {
                    showToast(this.localize('操作过于频繁'))
                    return {success: false, code: 3}
                }
                if (result?.code !== 200 || result?.msg?.withdrawNonce === null || !result?.msg?.timestamp || !result?.msg?.deadline || result?.msg?.nodeBurnAmount === null || !result?.msg?.signature) {
                    showToast(this.localize('参数获取失败'))
                    hideLoading(loadingId)
                    return
                }

                const {success, txHash} = await sendLpTrans('claimRewardWithAuth', [parseUnits(withdrawableFac, 18), result?.msg?.withdrawNonce, result?.msg?.timestamp, result?.msg?.deadline, tokenId, result?.msg?.nodeBurnAmount, result?.msg?.signature])
                if (success === true) {
                    await postRequestAsync('reward/reportClaimCommunityFacReward', {
                        wallet: this.myWalletAddress,
                        amount: withdrawableFac,
                        tokenId: tokenId,
                        tx: txHash
                    })
                    showToast(this.localize('领取成功'))
                    await sleep(3000)
                    await this.getMyFacRewardInfo()
                }
            } finally {
                hideLoading(loadingId)
            }
        },
        async onClaimAllFacReward() {
            if (Number(this.totalWithdrawableFac.toFixed(10)) <= 0) {
                showToast(this.localize('没有可提取的FAC'))
                return
            }
            const loadingId = v4()
            showLoading(this.localize('操作中'), loadingId)
            try {
                const {tokenId, amount} = await getMyBurnableNftTokenIdForFacToken(this.myWalletAddress, parseUnits(this.totalWithdrawableFac.toFixed(10), 18))
                if (tokenId === null) {
                    showToast(this.localize('没有可用的能量'))
                    hideLoading(loadingId)
                    return
                }

                const withdrawableFac = Math.floor(this.totalWithdrawableFac).toString()
                const result = await postRequestAsync('sig/getLpClaimRewardSig', {
                    wallet: this.myWalletAddress,
                    amount: withdrawableFac,
                    tokenId: tokenId
                })
                if (result.code === 700) {
                    showToast(this.localize('操作过于频繁'))
                    return {success: false, code: 3}
                }
                if (result?.code !== 200 || result?.msg?.withdrawNonce === null || !result?.msg?.timestamp || !result?.msg?.deadline || result?.msg?.nodeBurnAmount === null || !result?.msg?.signature) {
                    showToast(this.localize('参数获取失败'))
                    hideLoading(loadingId)
                    return
                }

                const {success, txHash} = await sendLpTrans('claimRewardWithAuth', [parseUnits(withdrawableFac, 18), result?.msg?.withdrawNonce, result?.msg?.timestamp, result?.msg?.deadline, tokenId, result?.msg?.nodeBurnAmount, result?.msg?.signature])
                if (success === true) {
                    await postRequestAsync('reward/reportClaimFacReward', {
                        wallet: this.myWalletAddress,
                        amount: withdrawableFac,
                        tokenId: tokenId,
                        tx: txHash
                    })
                    showToast(this.localize('领取成功'))
                    await sleep(3000)
                    await this.getMyFacRewardInfo()
                }
            } finally {
                hideLoading(loadingId)
            }
        },
        async onClaimAllUsdtReward() {
            const loadingId = v4()
            showLoading(this.localize('操作中'), loadingId)
            try {
                await this.withdrawMyDirectReward()
                await this.withdrawResonanceReward()
                await this.withdrawMyLevelReward()
                await this.withdrawMyCommunityReward()
            } finally {
                hideLoading('all')
            }
        },
        async withdrawResonanceReward() {
            let resonanceReward = Math.floor(this.availableResonanceRewardU)
            if (resonanceReward < 1) {
                // showToast(this.localize('没有可领取的共振奖励'))
                return
            }
            const {tokenId, amount} = await getMyBurnableNftTokenId(this.myWalletAddress, parseUnits(resonanceReward.toString(), 18))
            if (tokenId === null) {
                showToast(this.localize('没有可用的能量'))
                hideLoading()
                return
            }

            if (amount < resonanceReward) {
                resonanceReward = truncateDecimals(amount)
            }

            const {success} = await sendInteractorTrans('withdrawNftResonanceReward', [parseUnits(resonanceReward.toString(), 18), tokenId])
            if (success === true) {
                showToast(this.localize('共振奖励提取成功'))
                await sleep(3000)
                const resonanceRewardInfo = await interactorEthCall('resonanceRewardMap', [this.myWalletAddress])
                this.totalResonanceRewardU = Number(formatUnits(resonanceRewardInfo[0][0], 18))
                this.distributedResonanceRewardU = Number(formatUnits(resonanceRewardInfo[0][1], 18))
                this.availableResonanceRewardU = this.totalResonanceRewardU - this.distributedResonanceRewardU
            } else {
                showToast(this.localize('共振奖励提取失败'))
            }
        },
        async withdrawMyDirectReward() {
            if (this.availableDirectReferrerRewardU < 1) {
                // showToast(this.localize('没有可领取的直推奖励'))
                return {success: false, code: 1}
            }
            const loadingId = v4()
            try {
                showLoading(this.localize('操作中'), loadingId)
                let directReward = Math.floor(this.availableDirectReferrerRewardU)
                const {tokenId, amount} = await getMyBurnableNftTokenId(this.myWalletAddress, parseUnits(truncateDecimals(this.availableDirectReferrerRewardU, 10).toString(), 18))
                if (tokenId === null) {
                    showToast(this.localize('没有可用的能量'))
                    hideLoading()
                    return {success: false, code: 2}
                }
                if (amount < directReward) {
                    directReward = Math.floor(amount)
                }
                const {success} = await sendInteractorTrans('withdrawDirectReferrerReward', [parseUnits(directReward.toString(), 18), tokenId])
                if (success === true) {
                    showToast(this.localize('直推奖励提取成功'))
                    await sleep(3000)
                    const distributedLevelRewardInfo = await sendInteractorTrans('levelDistributedMap', [this.myWalletAddress])
                    this.distributedLevelReward = Number(formatUnits(distributedLevelRewardInfo.toString(), 18))
                    return {success: true}
                }
            } finally {
                hideLoading(loadingId)
            }

        },
        async withdrawMyLevelReward() {
            let levelReward = Math.floor(this.availableLevelReward)
            if (levelReward === 0) {
                return {success: false, code: 1}
            }

            const loadingId = v4()
            try {
                showLoading(this.localize('操作中'), loadingId)
                const {tokenId, amount} = await getMyBurnableNftTokenId(this.myWalletAddress, parseUnits(levelReward.toString(), 18))
                if (tokenId === null) {
                    showToast(this.localize('没有可用的能量'))
                    hideLoading()
                    return {success: false, code: 2}
                }
                if (amount < levelReward) {
                    levelReward = Math.floor(amount)
                }
                // const rewardAmount = truncateDecimals(this.availableLevelReward, 10)
                // const rewardAmount = truncateDecimals(this.availableLevelReward, 10)
                const result = await postRequestAsync('sig/getEnergyWithdrawSigLevelReward', {
                    wallet: this.myWalletAddress,
                    tokenId: tokenId,
                    amount: levelReward.toString()
                })

                if (result.code === 700) {
                    showToast(this.localize('操作过于频繁'))
                    return {success: false, code: 3}
                }
                if (result?.code !== 200 || result?.msg?.nonce === null || !result?.msg?.timestamp || !result?.msg?.deadline || !result?.msg?.signature) {
                    showToast(this.localize('参数获取失败'))
                    return {success: false, code: 3}
                }
                const {success, error} = await sendInteractorTrans('withdrawLevelReward', [parseUnits(levelReward.toString(), 18), tokenId, result?.msg?.nonce, result?.msg?.timestamp, result?.msg?.deadline, result?.msg?.signature])
                if (success === true) {
                    showToast(this.localize('层级奖励提取成功'))
                    await sleep(3000)
                    const distributedLevelRewardInfo = await interactorEthCall('levelDistributedMap', [this.myWalletAddress])
                    this.distributedLevelReward = Number(formatUnits(distributedLevelRewardInfo.toString(), 18))
                    return {success: true}
                } else {
                    showToast(error)
                }
                return {success: false}
            } finally {
                hideLoading(loadingId)
            }

        },
        async withdrawMyCommunityReward() {
            let communityReward = Math.floor(this.availableCommunityReward)
            if (communityReward === 0) {
                return {success: false, code: 1}
            }

            const loadingId = v4()
            try {
                showLoading(this.localize('操作中'), loadingId)
                // const rewardAmount = Math.floor(this.availableCommunityReward)
                console.log(`rewardAmount:${communityReward}`)
                const {tokenId, amount} = await getMyBurnableNftTokenId(this.myWalletAddress, parseUnits(communityReward.toString(), 18))

                if (tokenId === null) {
                    showToast(this.localize('没有可用的能量'))
                    hideLoading()
                    return {success: false, code: 2}
                }
                if (amount < communityReward) {
                    communityReward = Math.floor(amount)
                }
                const result = await postRequestAsync('sig/getEnergyWithdrawSigCommunityReward', {
                    wallet: this.myWalletAddress,
                    tokenId: tokenId,
                    amount: communityReward.toString()
                })

                if (result.code === 700) {
                    showToast(this.localize('操作过于频繁'))
                    return {success: false, code: 3}
                }
                if (result?.code !== 200 || result?.msg?.nonce === null || !result?.msg?.timestamp || !result?.msg?.deadline || !result?.msg?.signature) {
                    showToast(this.localize('参数获取失败'))
                    return {success: false, code: 3}
                }

                console.log(`result?.code:${result?.code}`)
                const {success, error} = await sendInteractorTrans('withdrawCommunityReward', [parseUnits(communityReward.toString(), 18), tokenId, result?.msg?.nonce, result?.msg?.timestamp, result?.msg?.deadline, result?.msg?.signature])
                if (success === true) {
                    showToast(this.localize('社区奖励提取成功'))
                    await sleep(3000)
                    const distributedCommunityRewardInfo = await interactorEthCall('communityRewardDistributedMap', [this.myWalletAddress])
                    console.log(`distributedCommunityRewardInfo: ${distributedCommunityRewardInfo}`)
                    this.distributedCommunityReward = Number(formatUnits(distributedCommunityRewardInfo.toString(), 18))
                    return {success: true}
                } else {
                    showToast(error)
                }
                return {success: false}
            } finally {
                hideLoading(loadingId)
            }
        },
        getBtnTxt() {
            if (this.currentSelectedTab === 'USDT') {
                return this.localize('领取')
            } else {
                return this.localize('提取')
            }
        },
        async getMyComputingPower() {
            const cpResult = await postRequestAsync('cp/myComputingPower', {
                wallet: this.myWalletAddress
            })
            if (cpResult?.code === 200 && cpResult?.msg?.computingPower !== null) {
                this.totalComputingPower += cpResult?.msg?.computingPower
            }
        },
        async getNodeFuel() {
            const cpResult = await postRequestAsync('fuel/getNodeFuel', {
                wallet: this.myWalletAddress
            })
            if (cpResult?.code === 200 && cpResult?.msg?.fuel !== null) {
                this.totalFuel += cpResult?.msg?.fuel
            }
        }
    }
}
</script>
<style scoped>

.assets-page-container {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding-top: 7em;
    align-items: center;
    box-sizing: border-box;
    gap: 1em;
    padding-bottom: 5em;
}

.assets-header {
    font-size: 2em;
    color: #48FFA1;
}

.empty-page-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 2em;
    box-sizing: border-box;
    align-items: center;
}

.empty-page-img {
    width: 10em;
    opacity: 0.3;
}

.empty-page-txt {
    font-size: 2em;
    color: #48FFA1;
    opacity: 0.3;
}

.assets-info-container {
    display: flex;
    flex-direction: column;
    width: 95%;
    margin-top: 20em;
    padding: 2em 2em 2em 2em;
    box-sizing: border-box;
    align-items: start;
    gap: 2em;
}

.assets-info-item {
    color: #48FFA1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.assets-info-item-txt {
    font-size: 1.4em;
}

.assets-info-item-btn {
    font-size: 1.4em;
    line-height: 1.4em;
    padding: 0.2em 0.6em;
    background-color: #48FFA1;
    color: #090600;
    border-radius: 0.2em;
}

.tab-container {
    margin-top: 2em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1em;
}

.asset-tab {
    font-size: 2em;
    color: #2DC73E;
}

.asset-tab.active {
    font-size: 2em;
    color: #38FF59;
    text-decoration: underline;
    text-decoration-color: #38FF59;
}

.page-container {
    background: #43413D;
    background: linear-gradient(180deg, rgba(67, 65, 61, 1) 0%, rgba(8, 6, 1, 1) 100%);
}

.my-asset-bg {
    width: 100%;
    position: absolute;
    opacity: 0.14;
    left: 50%;
    top: 5em;
    transform: translate(-50%);
}

.asset-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 1em;
    border-bottom: 1px solid #ffffff;
}

.asset-row-daily {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 1em;
    border-bottom: 1px solid #38FF59;
}

.asset-label {
    font-size: 1.6em;
    color: #ffffff;
}

.asset-label-daily{
    font-size: 1.4em;
    color: #38FF59;
}

.asset-label-with-arrow {
    font-size: 1.6em;
    color: #ffffff;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.asset-label-available{
    color: #38FF59;
}

.asset-label-available-total{
    color: #38FF59;
    font-size: 1.6em;
}

.asset-arrow-down {
    width: 1.6em;
}

.claim-btn {
    /*   position: absolute;
       bottom: 4em;
       left: 50%;
       transform: translateX(-50%);*/
    font-size: 1.6em;
    background-color: #38FF59;
    color: #000000;
    padding: 0.4em 0.8em;
    border-radius: 0.1em;
}

.rotate-180 {
    transform: rotate(180deg);
}

</style>